import React, { useState } from "react";
import { FormBuilder, Form } from "@redriver/cinnamon";
import { Grid, Button } from "semantic-ui-react";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Pen from "features/../../../shared/assets/pen.svg";
import Save from "features/../../../shared/assets/save.svg";
import {
  getSheetSystemSettings,
  updateSheetSystemSettings,
} from "../../actions";

const SheetSystemSettings = ({ settingsId }) => {
  return (
    <FormBuilder
      initialReadOnly
      loadAction={getSheetSystemSettings}
      loadParams={{ settingsId }}
      submitAction={updateSheetSystemSettings}
      submitParams={{ settingsId }}
      renderForm={(formProps, state, events) => (
        <Form {...formProps}>
          <div className="extra-settings-panel-top">
            <div className="extra-settings-panel-columns paper">
              <div className="content-panel">
                <div className="office-general-settings">
                  <h4 className="settings-title">Sheet Settings</h4>
                  <div className="content-container principal-list">
                    <div className="action-bar-div">
                      <div className="cin action-bar-item">
                        <PermissionCheck
                          target={Targets.Defaults}
                          action={Actions.Edit}
                        >
                          {!state.readOnly && (
                            <Button
                              primary
                              className="cancel-title-action"
                              floated="right"
                              content="Cancel"
                              onClick={events.onReset}
                            />
                          )}
                          <IconButton
                            primary
                            icon={state.readOnly ? Pen : Save}
                            content={state.readOnly ? "Edit" : "Save"}
                            floated="right"
                            onClick={() =>
                              state.readOnly
                                ? events.onToggleReadOnly()
                                : events.onSubmit({
                                    reset: ["readOnly"],
                                  })
                            }
                            className={
                              !state.readOnly ? "positive-title-action" : null
                            }
                          />
                        </PermissionCheck>
                      </div>
                    </div>
                  </div>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Form.Checkbox
                          label="Disable Sheet Locking"
                          field="disableSheetLocking"
                          disabled={state.readOnly}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

export default SheetSystemSettings;
